var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tbody',_vm._l((_vm.units),function(unit){return _c('EmPrice',{key:unit,attrs:{"base_unit":_vm.symbol.unit,"price":_vm.price(unit),"unit":unit,"hidden_units":_vm.symbol.hidden_units,"currency_code":_vm.currency_code}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }